<div class="w-full py-1 px-2" [formGroup]="formGroup">
  <div class="checkbox-card-wrapper p-4 rounded-lg border border-gray-200 dark:border-gray-800 bg-[#f8fafc] dark:bg-[#1b1c24] transition-all duration-150">
    <label class="flex items-start cursor-pointer select-none">
      <input
        type="checkbox"
        class="checkbox w-4.5 h-4.5 rounded text-blue-600 focus:ring-blue-500/20 border-gray-300 dark:border-gray-700 bg-white dark:bg-[#111217] cursor-pointer mt-0.5"
        [formControlName]="fields.fieldName"
        [id]="'option_' + fields.fieldName"
        (change)="onCheckboxChange()"
      />
      <div class="flex flex-col ml-3.5">
        <span class="text-sm font-semibold text-gray-900 dark:text-white leading-tight">
          {{ formattedDisplayName }}
        </span>
        <span *ngIf="fields.helpText || fields.uiOptions?.subText" class="text-xs text-gray-500 dark:text-gray-400 mt-1.5 leading-normal max-w-md">
          {{ fields.helpText || fields.uiOptions?.subText }}
        </span>
      </div>
    </label>
  </div>

  <!-- Validation Message -->
  <div *ngIf="showError" class="text-danger text-sm mt-1.5 ml-2">
    You must accept the {{ fields.displayName }}
  </div>
</div>
